import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f25026"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "energy-top clearfix" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top-item" }, " 节能积分说明 ")
], -1))
const _hoisted_2 = { class: "page-box integra-desc" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "num" }, "1. "),
  /*#__PURE__*/_createTextVNode(" 加班的时候设置加班时间，积分1 ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num" }, "2.", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 办公中暂时不需要")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("，持续时间大于等于0.5，小于1小时无任何开启，积分0.5 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num" }, " 3. ", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 办公中暂时不需要 ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("，持续时间大于等于1，小于2小时无任何开启，积分1 ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num" }, "4.", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 办公中暂时不需要 ")
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("， 持续时间大于等于2小时无任何开启，积分2 ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "num" }, " 5."),
  /*#__PURE__*/_createTextVNode(" 调节至室内温度大于等于26\"C，积分1 ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "num" }, "6."),
  /*#__PURE__*/_createTextVNode(" 供暖季，调节至室内温度小于等于20℃，积分1 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_4,
        _hoisted_5,
        (_ctx.portait.light)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "照明&"))
          : _createCommentVNode("", true),
        (_ctx.portait.airConditioner)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "空调"))
          : _createCommentVNode("", true),
        _hoisted_8
      ]),
      _createElementVNode("p", null, [
        _hoisted_9,
        _hoisted_10,
        (_ctx.portait.light)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "照明&"))
          : _createCommentVNode("", true),
        (_ctx.portait.airConditioner)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 空调"))
          : _createCommentVNode("", true),
        _hoisted_13
      ]),
      _createElementVNode("p", null, [
        _hoisted_14,
        _hoisted_15,
        (_ctx.portait.light)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "照明&"))
          : _createCommentVNode("", true),
        (_ctx.portait.airConditioner)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "空调"))
          : _createCommentVNode("", true),
        _hoisted_18
      ]),
      _hoisted_19,
      _hoisted_20
    ])
  ], 64))
}